// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"c837f840","678":"d1d241fc","787":"ff97d96a"}[chunkId] + ".chunk.js";
};